/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_WriteInputs */

const en_directory_submit_enrich_stage_write = /** @type {(inputs: Directory_Submit_Enrich_Stage_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save listing`)
};

const zh_directory_submit_enrich_stage_write = /** @type {(inputs: Directory_Submit_Enrich_Stage_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存收录`)
};

/**
* | output |
* | --- |
* | "Save listing" |
*
* @param {Directory_Submit_Enrich_Stage_WriteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_write = /** @type {((inputs?: Directory_Submit_Enrich_Stage_WriteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_WriteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_write(inputs)
	return zh_directory_submit_enrich_stage_write(inputs)
});
export { directory_submit_enrich_stage_write as "directory.submit.enrich.stage.write" }